import { stringifyXml } from './XmlParser'

/** Ledm Error do track the errors happened during the LEDM parse process */
export class LedmSearchServiceError extends Error {
  constructor(message, xmlArtifact) {
    super(message)
    this.xmlArtifact = stringifyXml(xmlArtifact)
  }
}
